import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandlerThunk } from '../../App/App.thunk';
import { internshipStatusService } from '../../InternshipStatus/InternshipStatus.service';
import { InternshipStatus } from '../../InternshipStatus/InternshipStatus.type';

const THUNK_PREFIX = 'internshipStatusControl';

interface Params {
  q?: string;
  page?: number | string;
  sort?: string;
}

export const getInternshipStatusControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/internshipStatus/getInternshipStatusThunk`,
  async ({ q: search, page }: Params, thunkAPI) => {
    const params = { search, page };

    try {
      const { data } = await internshipStatusService.get(params);

      return data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const createInternshipStatusControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/internshipStatus/createInternshipStatusThunk`,
  async (status: Omit<InternshipStatus, 'id'>, thunkAPI) => {
    try {
      const { data } = await internshipStatusService.create(status);
      return data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const updateInternshipStatusControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/internshipStatus/updateInternshipStatusThunk`,
  async (status: InternshipStatus, thunkAPI) => {
    try {
      const response = await internshipStatusService.update(status);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const deleteInternshipStatusControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/internshipStatus/deleteInternshipStatusThunk`,
  async (id: number, thunkAPI) => {
    try {
      await internshipStatusService.delete(id);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
